import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styles from "./Buttons.module.scss";
import React from "react";
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from "react-tooltip";

Buttons.propTypes = {
    buttons: PropTypes.array
}

function Buttons(props) {
    const {buttons} = props;

    function renderButton(button, index) {
        let activeClass = button.active ? ' ' + styles.active : ''
        let icon = button.icon && <FontAwesomeIcon className={styles.icon + activeClass} icon={button.icon}/>
        let text = button.text && <div className={styles.icon + ' ' + styles.text + activeClass}>{button.text}</div>

        return (
            <div style={{display:"flex",alignItems:"center"}} key={index} data-tooltip-id="toolbar-button-tooltip" data-tooltip-content={button.tip}>
                <div className={styles.wrapper} onClick={button.clickHandler}>
                    {icon || text}
                </div>
            </div>
        )
    }

    return (
        <>
            <ReactTooltip id="toolbar-button-tooltip" delayShow={500}/>
            {buttons.length ? buttons.map((button, index) => renderButton(button, index)) : ""}
        </>
    )
}

export default Buttons;